import React from 'react'
const XIconLoading = (props: { className?: string }) => {
	return (
		<div {...props}>
			<svg {...props} width='77' height='77' viewBox='0 0 77 77' fill='transparent' xmlns='http://www.w3.org/2000/svg'>
				<rect
					x='1.01611'
					y='1.54468'
					width='74.3091'
					height='74.3091'
					rx='37.1546'
					stroke='currentColor'
					strokeWidth='2'
					strokeDasharray='150 300'
					strokeDashoffset='0'
				>
					<animateTransform
						attributeName='transform'
						attributeType='XML'
						type='rotate'
						from='0 38.5 38.5'
						to='360 38.5 38.5'
						dur='1.5s'
						repeatCount='indefinite'
					/>
				</rect>
				<path
					d='M36.6852 18.9423C36.5844 18.4054 36.507 17.9921 36.4051 17.4481L32.6859 20.0618L31.834 18.8216L28.9998 22.0554L28.0687 20.9863L25.7081 24.7191L24.4483 23.6962L22.4389 27.3157C22.8639 27.509 23.1739 27.645 23.4799 27.7902C24.9058 28.4319 26.1799 29.368 27.2184 30.537C28.2569 31.706 29.0363 33.0815 29.5056 34.5731C29.7012 35.0772 29.7956 35.6149 29.7832 36.1554C29.7708 36.696 29.652 37.2289 29.4336 37.7235C28.4857 39.903 29.2218 42.3103 31.056 43.4574C31.0999 42.9266 31.1195 42.4259 31.1856 41.9318C31.7133 37.9752 34.8364 36.2704 38.1956 36.5479C40.9771 36.7777 43.0015 38.9106 43.4732 41.658C43.948 44.4247 42.7866 46.82 40.1983 48.1214C37.2212 49.6178 34.013 49.8942 30.7816 49.3896C27.9995 48.9549 25.5803 47.5368 23.2533 46.0102C21.9741 45.1714 20.7387 44.2659 19.4285 43.3522C18.8228 45.6408 21.1649 46.2703 21.8033 47.8276L20.7097 48.7385L24.8758 52.1845L23.5257 53.279C25.3531 54.1412 27.0553 54.9447 28.8227 55.7781L27.6494 57.0047L33.5746 58.0518L32.9199 59.2867L38.8531 58.7715C38.7392 59.2597 38.6555 59.6163 38.5255 60.1731L45.2263 57.9326C45.1734 58.4899 45.1369 58.8762 45.084 59.4441L50.9836 55.268L51.3462 56.6522L55.5049 50.7751L56.4841 52.3154L58.3787 45.0569L59.5082 45.8676V38.8368C60.0222 38.9885 60.462 39.1181 61.0737 39.2977L58.4954 32.9703L60.0863 32.8527L55.8997 27.5603L57.5891 27.2458L51.8358 23.2135L53.4691 22.1227L46.6945 20.2767L47.6623 18.829H41.5356C41.5103 18.2625 41.4886 17.7776 41.4639 17.2253L36.6849 18.9389'
					fill='currentColor'
				/>
				<path
					d='M19.7174 36.987C19.7177 37.1459 19.7809 37.2983 19.8934 37.4107C20.0058 37.5231 20.1582 37.5864 20.3172 37.5865C20.4762 37.5864 20.6286 37.5231 20.741 37.4107C20.8534 37.2983 20.9167 37.1459 20.9169 36.987C20.9167 36.828 20.8534 36.6757 20.741 36.5633C20.6286 36.4509 20.4762 36.3877 20.3172 36.3875C20.1582 36.3877 20.0058 36.4509 19.8934 36.5633C19.7809 36.6757 19.7177 36.828 19.7174 36.987Z'
					fill='currentColor'
				/>
				<path
					d='M20.9187 29.3544C19.1252 32.4895 17.3633 35.6424 15.633 38.8132C15.4138 39.2376 15.2902 39.7048 15.2707 40.1821C15.2226 41.1448 15.84 41.6472 16.7833 41.4152C17.3124 41.29 17.8172 41.0784 18.2774 40.7889C19.336 40.1012 20.3519 39.3475 21.3801 38.6122C23.3726 37.1861 25.3993 35.8534 28.1114 36.2403C27.757 32.9762 24.8949 29.6649 21.8378 28.9158C21.8075 28.9087 21.7764 28.9053 21.7453 28.9057C21.5838 28.9184 21.4269 28.965 21.2847 29.0424C21.1424 29.1198 21.0181 29.2263 20.9198 29.355M19.4095 36.988C19.41 36.7471 19.5059 36.5162 19.6762 36.3459C19.8466 36.1756 20.0774 36.0797 20.3183 36.0792C20.5592 36.0798 20.79 36.1757 20.9602 36.346C21.1305 36.5164 21.2264 36.7472 21.2269 36.988C21.2263 37.2288 21.1304 37.4596 20.9601 37.6299C20.7899 37.8001 20.5591 37.896 20.3183 37.8966C20.0775 37.896 19.8467 37.8003 19.6763 37.63C19.506 37.4597 19.4101 37.2289 19.4095 36.988Z'
					fill='currentColor'
				/>
			</svg>
		</div>
	)
}

export default XIconLoading
